<template>
  <div class="datasets-filters">
    <!-- USERGROUP -->
    <div v-if="$config.isSaas && !userSession.isSuperuser()">
      <label for="">
        {{ capitalizeFirstLetter($tc('words.organisation')) }}
      </label>
      <b-form-input
        :value="currentDomainOrganisation.value.display_name"
        readonly
        disabled
      />
    </div>
    <div v-else>
      <label for="">
        {{ capitalizeFirstLetter($tc('words.organisation')) }} / {{ capitalizeFirstLetter($tc('words.userGroup')) }}
      </label>
      <SearchUsergroups
        v-model="selectedUsergroup"
        :disabled="!userSession.isSuperuser() && userSession.getUserEditorRoles().length <= 1"
        :types="['organisation', 'user-group']"
        :placeholder="$t('forms.datasets.organisation.help')"
        :usergroup="selectedUsergroup"
        :reset-after="false"
        :limit="10"
        @select="selectUsergroup"
        @remove="selectUsergroup"
      />
    </div>

    <!-- PUBLICATION -->
    <div>
      <label for="">
        {{ $t('datasets.publishedInCatalog') }}
      </label>
      <div class="form-check">
        <input
          id="publishedDatasetFilter"
          v-model="isPublishChecked"
          class="form-check-input"
          type="checkbox"
          value=""
          @change="setPublicationFilter"
        >
        <label
          class="form-check-label"
          for="publishedDatasetFilter"
        >
          {{ $t('words.published') }}
        </label>
      </div>
      <div class="form-check">
        <input
          id="unpublishedDatasetFilter"
          v-model="isUnpublishChecked"
          class="form-check-input"
          type="checkbox"
          value=""
          @change="setPublicationFilter"
        >
        <label
          class="form-check-label"
          for="unpublishedDatasetFilter"
        >
          {{ $t('words.unpublished') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import SearchUsergroups from '@/components/Searchbars/SearchUsergroups.vue';

export default {
  name: 'DatasetsFilters',

  components: {
    SearchUsergroups
  },

  data() {
    return {
      selectedRecordTypes: [],
      selectedUsergroup: null,
      isPublishChecked: false,
      isUnpublishChecked: false,
    };
  },

  computed: {
    ...mapState('datasets', [
      'datasetsRecordTypes'
    ])
  },

  async created() {
    if (!this.userSession.isSuperuser()) {
      this.SET_USERGROUPS_FILTERS({
        filter: 'status__in',
        value: 2
      });
      this.SET_USERGROUPS_FILTERS({
        filter: 'user__role__in',
        value: ['1', '2']
      });
    }
    if (this.$config.isSaas && !this.userSession.isSuperuser()) {
      this.selectUsergroup(this.currentDomainOrganisation.value);
    } else if (!this.userSession.isSuperuser() && this.userSession.getUserEditorRoles().length === 1) {
      this.selectUsergroup(this.userSession.getUserEditorRoles()[0].usergroup);
    }
    if (this.datasetsRecordTypes.length === 0) {
      await this.GET_DATASETS_RECORD_TYPES();
    }
  },

  beforeRouteLeave(to, from, next) {
    this.RESET_USERGROUPS_FILTERS();
    next();
  },

  methods: {
    ...mapMutations('usergroups', [
      'SET_USERGROUPS_FILTERS',
      'RESET_USERGROUPS_FILTERS'
    ]),
    ...mapActions('datasets', [
      'GET_DATASETS_RECORD_TYPES'
    ]),

    selectUsergroup(e) {
      this.$emit('set', {
        filter: 'usergroup_id',
        value: e && e.id ? e.id : null
      });
    },

    setPublicationFilter() {
      let value = null;
      if (this.isPublishChecked && !this.isUnpublishChecked) {
        value = 'true';
      }
      if (!this.isPublishChecked && this.isUnpublishChecked) {
        value = 'false';
      }
      this.$emit('set', {
        filter: 'publish',
        value: value
      });
    },
  }
};
</script>

<style lang="less" scoped>
.datasets-filters {
  padding: 1rem;
  box-shadow: 0 0 2px 1px #b9b9ba;
  border-radius: 2px;

  label:not(.form-check-label) {
    margin-top: 1rem;
    font-size: 0.9rem;
  }

  .form-check {
    margin: .5em 1rem .5em;
  }
}
</style>